
import { configureStore } from '@reduxjs/toolkit';
import segmenterReducer from './slices/segmenterSlice';
import aggregatorReducer from './slices/aggregatorSlice';
import chartReducer from './slices/chartSlice';
import segmenterChatReducer from './slices/segmenterChatSlice';
import dataWorkbenchChatReducer from './slices/dataWorkbenchChatSlice';
import campaignBriefReducer from './slices/campaignBriefSlice';
import notificationsReducer from './slices/notificationsSlice';

const store = configureStore({
  reducer: {
    segmenter: segmenterReducer,
    segmenterChat: segmenterChatReducer,
    chart: chartReducer,
    aggregator: aggregatorReducer,
    dataWorkbenchChat: dataWorkbenchChatReducer,
    campaignBrief: campaignBriefReducer,
    notifications: notificationsReducer,
  },
});

export default store;